export const __ENV_DEV__ = process.env.NODE_ENV === "development"
